import { URLPattern } from "urlpattern-polyfill";

import { webComponentsRoutes } from "@astrocentro-webapp/ui/config/web-components-routes";

globalThis.URLPattern = URLPattern;

export class RouterAdapter {
  #routes;
  #rawRoutes;
  #baseURL;
  #history;

  constructor(routes = webComponentsRoutes, baseURL = window.location.origin) {
    this.#baseURL = baseURL;
    this.#rawRoutes = routes;
    this.#routes = this.#createRoutes(this.#rawRoutes);
    this.#history = window.history;
  }

  #createRoutes(routes) {
    return routes.map(({ name, path }) => {
      const pattern = `${this.#baseURL}${path}`;
      const urlPattern = new URLPattern(pattern);
      const isCurrent = urlPattern.test(this.#getCurrentURLPathname());
      const params = isCurrent
        ? urlPattern.exec(this.#getCurrentURLPathname()).pathname.groups
        : null;
      return {
        name,
        path,
        params,
        query: isCurrent
          ? this.#createQueryStrings(window.location.search)
          : null,
        isCurrent,
      };
    });
  }

  #createQueryStrings(params) {
    const urlSearchParams = new URLSearchParams(params);
    const query = {
      toString: () => params,
    };

    for (const [key, value] of urlSearchParams.entries()) {
      query[key] = value;
    }

    return query;
  }

  #getCurrentURLPathname() {
    return `${this.#baseURL}${window.location.pathname}`;
  }

  get route() {
    return this.#routes.find((route) => route.isCurrent === true);
  }

  push(path, options = {}) {
    const url = options.withQueryStrings
      ? `${this.#baseURL}${path}${this.route.query.toString()}`
      : `${this.#baseURL}${path}`;

    if (options.reload) {
      this.#history.pushState({}, null, url);
      location.reload();
    } else {
      this.#history.pushState({}, null, url);
      this.#routes = this.#createRoutes(this.#rawRoutes);
    }
  }

  set(param, value) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.set(param, value);
    this.route.query = this.#createQueryStrings(
      `?${urlSearchParams.toString()}`
    );
    this.push(window.location.pathname, { withQueryStrings: true });
  }

  remove(param) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.delete(param);
    this.route.query = this.#createQueryStrings(
      `?${urlSearchParams.toString()}`
    );
    this.push(window.location.pathname, { withQueryStrings: true });
  }
}
